/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Measure_Latency_P99_MeaningInputs */

const en_measure_latency_p99_meaning = /** @type {(inputs: Measure_Latency_P99_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`p99 response time: 99% of requests finish within ${i?.value}`)
};

const zh_hans1_measure_latency_p99_meaning = /** @type {(inputs: Measure_Latency_P99_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`p99 响应时间：99% 的请求在 ${i?.value} 内完成`)
};

const pt_br2_measure_latency_p99_meaning = /** @type {(inputs: Measure_Latency_P99_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tempo de resposta p99: 99% das requisições terminam em até ${i?.value}`)
};

const es_measure_latency_p99_meaning = /** @type {(inputs: Measure_Latency_P99_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tiempo de respuesta p99: el 99% de las solicitudes termina en ${i?.value} o menos`)
};

const fr_measure_latency_p99_meaning = /** @type {(inputs: Measure_Latency_P99_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Temps de réponse p99 : 99 % des requêtes se terminent en ${i?.value}`)
};

const de_measure_latency_p99_meaning = /** @type {(inputs: Measure_Latency_P99_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`p99-Antwortzeit: 99 % der Anfragen sind innerhalb von ${i?.value} fertig`)
};

const ru_measure_latency_p99_meaning = /** @type {(inputs: Measure_Latency_P99_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Время ответа p99: 99 % запросов завершается за ${i?.value}`)
};

const it_measure_latency_p99_meaning = /** @type {(inputs: Measure_Latency_P99_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tempo di risposta p99: il 99% delle richieste termina entro ${i?.value}`)
};

/**
* | output |
* | --- |
* | "p99 response time: 99% of requests finish within {value}" |
*
* @param {Measure_Latency_P99_MeaningInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_latency_p99_meaning = /** @type {((inputs: Measure_Latency_P99_MeaningInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Latency_P99_MeaningInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_latency_p99_meaning(inputs)
	if (locale === "pt-BR") return pt_br2_measure_latency_p99_meaning(inputs)
	if (locale === "es") return es_measure_latency_p99_meaning(inputs)
	if (locale === "fr") return fr_measure_latency_p99_meaning(inputs)
	if (locale === "de") return de_measure_latency_p99_meaning(inputs)
	if (locale === "ru") return ru_measure_latency_p99_meaning(inputs)
	if (locale === "it") return it_measure_latency_p99_meaning(inputs)
	return en_measure_latency_p99_meaning(inputs)
});